// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import organization from './organization'

const rootReducer = {
  auth,
  organization,
  navbar,
  layout
}

export default rootReducer
